<!-- eslint-disable vue/valid-v-model -->
<!--
 * @Author: wanglibo
 * @LastEditors: wanglibo
 * @Description: 营养门诊-患者基础信息
-->

<template>
  <div class="base-info-page">
    <div class="page-title">请完善以下信息，以便为您精准定制方案</div>
    <div class="form-wrapper">
      <van-form @submit="onSubmit">
        <van-field input-align="right" required error-message-align="right" v-model="formData.name" name="name"
          label="姓名" placeholder="请输入姓名" :rules="[{ required: true }]" />
        <van-field input-align="right" required :rules="[{ required: true }]" v-model="formData.gender" readonly
          clickable name="gender" label="性别" placeholder="请选择性别" is-link @click="showPickerFn('gender')" />
        <van-field v-model="formData.birthday" required :rules="[{ required: true }]" input-align="right" readonly
          clickable name="birthday" label="生日" placeholder="选择生日" is-link @click="showPickerFn('birthday')" />
        <van-field input-align="right" required v-model="formData.height" name="initHeight" label="身高(cm)" type="digit"
          placeholder="请输入身高" right-icon="cm" error-message-align="right"
          :rules="[{ required: true }, { pattern: /^\d+$/, message: '请输入正确的身高' }]" />
          <!-- 增加校验，只能输入数字和小数点 -->
        <van-field input-align="right" required v-model="formData.weight" name="initWeight" label="体重(kg)"
          right-icon="kg" placeholder="请输入体重" error-message-align="right"
          :rules="[{ required: true }, { pattern: /^\d+(\.\d+)?$/, message: '请输入正确的体重' }]" />
        <van-field input-align="right" required v-model="formData.phone" name="phone" label="手机号" placeholder="请输入手机号"
          error-message-align="right" :rules="[{ required: true }, { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号' }]" />
        <van-field input-align="right" required :rules="[{ required: true }]" v-model="formData.phyStatus" readonly
          clickable name="phyStatus" label="生理状态" placeholder="选择生理状态" is-link @click="showPickerFn('phyStatus')" />
        <van-field v-if="phyStatus == 5" input-align="right" required v-model="formData.phyStatusOtherDesc"
          name="phyStatusOtherDesc" label="具体疾病" placeholder="请输入具体疾病" error-message-align="right"
          :rules="[{ required: true }]" />
        <van-field input-align="right" required :rules="[{ required: true }]" v-model="formData.occType" readonly
          clickable name="occType" label="职业性质" placeholder="选择职业性质" is-link @click="showPickerFn('occType')" />
        <van-field input-align="right" required :rules="[{ required: true }]" v-model="formData.ethnicity" readonly
          clickable name="ethnicity" label="民族" placeholder="选择民族" is-link @click="showPickerFn('ethnicity')" />


        <van-popup v-model="showPicker" position="bottom">
          <!-- 日历弹框 -->
          <van-datetime-picker v-if="pickerType == 'birthday'" title="选择生日" type="date" @confirm="onConfirmCalendar"
            :min-date="minDate" :max-date="maxDate" v-model="currentDate" />
          <!-- 下拉选择 -->
          <van-picker v-else show-toolbar :columns="columns" @confirm="onConfirm" @cancel="showPicker = false" />

        </van-popup>


        <div class="next-btn-wrapper">
          <van-button round block color="#FBB13D" type="info" native-type="submit">下一页</van-button>
        </div>
      </van-form>
    </div>
  </div>
</template>

<script>
import { genders, phyStatusList, occTypeList, ethnicityList } from '../data'
const DictVO = {
  gender: genders,
  phyStatus: phyStatusList,
  occType: occTypeList,
  ethnicity: ethnicityList
}
export default {
  name: 'BaseInfo',
  props: {
    initData: {
      type: Object,

      default: () => { }
    }
  },
  data() {
    return {
      minDate: new Date(1826, 1, 1),
      maxDate: new Date(),
      showCalendar: false,
      showPicker: false,
      pickerType: '',
      columns: [],
      currentDate: new Date(),

      formData: {
        name: '',
        gender: '',
        birthday: '',
        height: '',
        weight: '',
        phone: '',
        phyStatus: '',
        occType: '',
        ethnicity: '',
      }
    }
  },
  created() {

  },
  mounted() {
    console.log('mounted', this.initData)
    if (this.initData) {
      this.formData = { ...this.initData }
    }
  },
  methods: {
    showPickerFn(key) {
      this.showPicker = true
      this.pickerType = key
      this.columns = DictVO[key]
    },
    closePicker() {
      this.showPicker = false
      this.columns = []
    },
    onConfirm(data) {
      if (this.pickerType == 'ethnicity') {
        this.formData.ethnicity = data
      } else {
        this[this.pickerType] = data.value
        this.formData[this.pickerType] = data.text
      }

      this.closePicker()
    },
    onConfirmCalendar(date) {
      this.formData.birthday = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
      this.closePicker();
    },
    onSubmit(values) {
      console.log("onSubmit", values, this)
      // this.$emit('nextStepBy',{type:'baseInfo',data:values})
      this.$emit('next-step', { type: 'baseInfo', data: { ...values, gender: this.gender, phyStatus: this.phyStatus, occType: this.occType } })
      // let query = { ...values, ...this.formData }
      // this.$toast('提交成功');
    }
  }
};
</script>

<style scoped>
div,
p,
ul,
li,
* {
  box-sizing: border-box;
}

.base-info-page {
  width: 100%;
  height: 100vh;
  padding: 2rem 0;
  display: flex;
  flex-direction: column;
}

.base-info-page .page-title {
  padding-left: calc(16px + 0.5rem);
  height: 1.83rem;
  font-weight: 500;
  font-size: 1.33rem;
  color: #333333;
  line-height: 1.83rem;
  margin-bottom: 10px;
}

.form-wrapper {
  flex: 1;
  padding: 0 0.5rem;
}

.next-btn-wrapper {
  margin-top: 6rem;
  height: 90px;
  padding: 0.33rem 2.08rem;
  /* box-shadow: inset 0rem 0.04rem 0rem 0rem rgba(0, 0, 0, 0.25); */
}

.van-cell {
  font-size: 1.63rem;
  padding: 14px 16px;
}

.van-ellipsis,
.van-picker__cancel,
.van-picker__confirm {
  font-size: 1.63rem;
}
</style>
